import React, { useState } from "react";
import { Box, Button, Flex, Image, Input, Link, Text } from "@chakra-ui/react";
import { PRIMARY_COLOR } from "../../constants/colors";
import api from "../../services/api";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { resolveCatalogContext, buildLoginPath } from "../../utils/catalogContext";

export default function ResetPassword() {
  const params = useParams();
  const { token } = params;
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();
  const { clientHash, sellerId } = resolveCatalogContext(params);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.length < 6) {
      toast.error("A senha deve ter no mínimo 6 caracteres!");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("As senhas não conferem!");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await api.post("/login/reset-password", { token, password });
      toast.success("Senha redefinida com sucesso!");

      // Se a URL do link não trazia o clientHash (link antigo), usa o
      // companyHash devolvido pelo backend pra não perder o catálogo.
      const resolvedClientHash = clientHash || response.data?.companyHash;
      navigate(buildLoginPath(resolvedClientHash, sellerId), { replace: true });
    } catch (err) {
      toast.error(
        err.response?.data?.error ??
          "Erro ao redefinir senha, tente novamente mais tarde!",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      bg="gray.50"
      p={4}
      flexDirection="column"
      gap="40px"
    >
      <Image src="/logo-aqvex.png" cursor="pointer" width="200px" />
      <Box
        as="form"
        onSubmit={handleSubmit}
        bg="white"
        rounded="lg"
        boxShadow="lg"
        p={{ base: 6, md: 10 }}
        width={{ base: "100%", sm: "420px" }}
      >
        <Flex flexDirection="column" width="100%" gap="10px">
          <Text fontWeight="600">Redefinir senha</Text>
          <Text fontSize="sm" color="gray.600" mb={2}>
            Escolha uma nova senha para acessar sua conta.
          </Text>
          <Flex flexDirection="column" gap="10px">
            <Text fontWeight="600">Nova Senha *</Text>
            <Input
              type="password"
              placeholder="Digite sua nova senha..."
              padding="15px"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Flex>
          <Flex flexDirection="column" gap="10px">
            <Text fontWeight="600">Confirmar Nova Senha *</Text>
            <Input
              type="password"
              placeholder="Confirme sua nova senha..."
              padding="15px"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </Flex>
          <Button
            type="submit"
            loading={isSubmitting}
            width="100%"
            backgroundColor={PRIMARY_COLOR}
            color="white"
          >
            Redefinir senha
          </Button>
          <Text textAlign="center" fontSize="sm" mt={2}>
            <Link
              color={PRIMARY_COLOR}
              fontWeight="600"
              cursor="pointer"
              onClick={() => navigate(buildLoginPath(clientHash, sellerId))}
            >
              Voltar para o login
            </Link>
          </Text>
        </Flex>
      </Box>
    </Flex>
  );
}
